import { InjectionToken } from '@angular/core';

export const DarkModeState = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  SYSTEM: 'SYSTEM'
} as const;

export type DarkModeState = typeof DarkModeState[keyof typeof DarkModeState];
export interface DarkMode {
  darkModeState: DarkModeState;
}

export const DARK_MODE_TOKEN = new InjectionToken<DarkMode>('DarkModeToken');